import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { DataTable } from '@warrenbrasil/nebraska-web';

import { PortfolioSectionType } from '@/modules/wealth/services/portfolio';

import { formattedColumns, formattedDataTable } from './helpers';

interface Props {
  data: PortfolioSectionType;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StocksTable',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: PortfolioSectionType;
}



const columns = computed(() => {
  return formattedColumns(props.data);
});

const dataTable = computed(() => {
  return formattedDataTable(props.data);
});

return { __sfc: true,props, columns, dataTable, DataTable }
}

})